import React, {useEffect, useState} from 'react';
import {usuarioAddDuck, usuarioAddThunk} from './duck';
import {useSelector, useDispatch} from 'react-redux';
import {constants, responseSelector, validateEmail} from '../utils/utils';

import {alertTypes} from '../utils/Alert';

import {UsuarioEditView} from './UsuarioEditView';
import {rolDescByName, rolesByName} from '../utils/constants';

function UsuarioAdd({history, match, token}) {
  const topAlertDefaultValue = {
    text: null,
    type: null,
    title: null,
    closable: false,
  };
  const [topAlert, setTopAlert] = useState(topAlertDefaultValue);

  const submitAlertDefaultValue = {
    text: null,
    type: null,
    title: null,
    closable: false,
  };

  const [submitAlert, setSubmitAlert] = useState(submitAlertDefaultValue);
  const dispatch = useDispatch();

  const usuarioAdd = useSelector(state => state.usuarioAdd);

  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [nombre, setNombre] = useState(null);
  const [direccion, setDireccion] = useState('');
  const [rolOption, setRolOption] = useState({
    value: rolesByName.selector,
    label: rolDescByName.selector,
  });
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [tel, setTel] = useState('+595');
  const [documento, setDocumento] = useState('');
  const [estadoOption, setEstadoOption] = useState(null);

  const [documentType, setDocumentType] = useState({
    value: 'CI',
    label: 'Cedula de identidad',
  });

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(usuarioAdd);

    if (error) {
      setSubmitAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });
      dispatch(usuarioAddDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      history.goBack();
      dispatch(usuarioAddDuck.actions.clear());
    }
  }, [dispatch, usuarioAdd]);

  function submit() {
    if (!validateEmail(username)) {
      setSubmitAlert({
        title: 'Error',
        text: 'Por favor proporcione un email con el formato correcto',
        type: alertTypes.danger,
        closable: false,
      });

      return;
    }

    if (!rolOption?.value || !username || !password || !nombre) {
      setSubmitAlert({
        title: 'Error',
        text: 'Por favor complete todos los campos',
        type: alertTypes.danger,
        closable: false,
      });
      return;
    }

    let data = {
      userToken: token.raw,
      username,
      email: username,
      password,
      nombre: nombre,
      document: documento,
      documentType: documentType?.value,
      fechaNacimiento: null,
      phoneNumber: tel === '+595' ? null : tel,
      rol: rolOption.value,
      address: {
        direccion,
        lat,
        lng,
      },
    };

    dispatch(usuarioAddThunk(data));
  }

  return (
    <UsuarioEditView
      mode="create"
      usuarioEdit={usuarioAdd}
      submit={submit}
      topAlert={topAlert}
      rolOption={rolOption}
      setRolOption={setRolOption}
      nombre={nombre}
      setNombre={setNombre}
      username={username}
      setUsername={setUsername}
      password={password}
      setPassword={setPassword}
      documentType={documentType}
      setDocumentType={setDocumentType}
      documento={documento}
      setDocumento={setDocumento}
      tel={tel}
      setTel={setTel}
      submitAlert={submitAlert}
      estadoOption={estadoOption}
      setEstadoOption={setEstadoOption}
      history={history}
      token={token}
    />
  );
}

export {UsuarioAdd};
